"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../../ApiManagerAdmin");
var ApiConfig_1 = require("../../config/ApiConfig");
/**
 * ANCHOR 코인 통계 API
 */
var ApiCoin = /** @class */ (function (_super) {
    __extends(ApiCoin, _super);
    function ApiCoin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_COIN_ALL = "/api/statistics/allUserCoin";
        _this.GET_COIN_DAY = "/api/statistics/userCoinDay";
        _this.GET_COIN_UNLOCKALL_BY_COMIC = "/api/statistics/unlockAllListByComic";
        _this.GET_COIN_UNLOCKALL_BY_DATE = "/api/statistics/unlockAllListByDate";
        _this.GET_COIN_COMIC_FREE_PURCHASE = "/api/statistics/comicFreePurchase";
        /**
         * 누적 코인 내역
         * @param accesstoken
         * @param startDate
         * @param endDate
         * @param timezone
         * @returns
         */
        _this.getCoinAllUser = function (accesstoken, startDate, endDate, timezone) {
            var data = {
                startDate: startDate,
                endDate: endDate,
                timezone: timezone,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_COIN_ALL,
                data: data,
            });
        };
        /**
         * 날짜별 코인 내역
         * @param accesstoken
         * @param startDate
         * @param endDate
         * @param timezone
         * @returns
         */
        _this.getCoinUserDay = function (accesstoken, startDate, endDate, timezone) {
            var data = {
                startDate: startDate,
                endDate: endDate,
                timezone: timezone,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_COIN_DAY,
                data: data,
            });
        };
        /**
         * 전체구매 (만화별)
         * @param accesstoken
         * @param request
         */
        _this.getCoinUnlockAllByComic = function (accesstoken, request) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_COIN_UNLOCKALL_BY_COMIC,
                data: request,
            });
        };
        /**
         * 전체구매 (일자별)
         * @param accesstoken
         * @param request
         * @returns
         */
        _this.getCoinUnlockAllByDate = function (accesstoken, request) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_COIN_UNLOCKALL_BY_DATE,
                data: request,
            });
        };
        /**
         * 무료회차 소장
         * @param accesstoken
         * @param request
         * @returns
         */
        _this.getCoinComicFreePurchase = function (accesstoken, request) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_COIN_COMIC_FREE_PURCHASE,
                data: request,
            });
        };
        return _this;
    }
    ApiCoin.getInstance = function (initValue) {
        if (!ApiCoin.classInstance) {
            this.classInstance = new ApiCoin(initValue);
        }
        return this.classInstance;
    };
    return ApiCoin;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiCoin;
